import { Backdrop, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography } from '@mui/material';
import React, { Fragment, memo, useEffect, useRef, useState } from 'react';
import { Br, Cut, Line, Printer, Text, Row, render } from 'react-thermal-printer';
import { useStyle } from './style';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { resetData } from '../../hooks/printPdf/thermalData';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { setSnackbar } from '../../hooks/snackBar/reducers';

const ExpenseCloseThermalPrint = () => {
    const data = useSelector(state => state.getThermalData)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const classes = useStyle()
    const [text, setText] = useState("Baby Corn 5 Kg")
    const [flag, setFlag] = useState(false)
    const [gst,setGst] = useState([])
    const [gData, setGData] = useState([])

    console.log('vanthuden', data)
    useEffect(()=>{
        if(data.onPress){
            console.log('vanthuden', data)
          if(data.getThermalData!==null ){
            // printableDiv.classList.add('printPDF')
            // printableDiv.classList.remove('printPDF')
            console.log(data.getThermalData.companyInfo.docno, 'Enna ithu')
            const docBill = data.getThermalData.companyInfo.docno
            console.log(docBill)
            const groupedData = _.groupBy(data.getThermalData.tableData,'cgstPerc')
            const result = _.map(groupedData,(val,tax)=>({
                cgstPerc : parseFloat(tax),
                gstAmt : _.sumBy(val, item=> parseFloat(item.cgstAmnt))
            }))
            // const groupData = _.groupBy(data.getThermalData.tableData, item => `${item.pro_name}_${item.hsn}_${item.mrp}_${item.sale_rate}_${item.cgstPerc}`)
            // console.log(groupData)
            // const getGroupData = _.map(groupData,(val,tax)=>({
            //     pro_name : val[0].pro_name,
            //     hsn : val[0].hsn,
            //     qty : _.sumBy(val, item=> parseFloat(item.qty)),
            //     sale_rate : val[0].sale_rate,
            //     mrp: val[0].mrp,
            //     totalAmt: _.sumBy(val, item=> parseFloat(item.totalAmt)),
            //     cgstAmnt : _.sumBy(val, item=> parseFloat(item.cgstAmnt)),
            //     cgstPerc: val[0].cgstPerc,
            //     disc1: val[0].disc1,
            //     // pur_rate: val[0].pur_rate,
            // }))
            // setGData(getGroupData)
            setGst(result)
         setFlag(true)
          }
        }
      
    },[data])
    useEffect(()=>{
      if(flag){
        window.print()
        dispatch(resetData())
        dispatch(setSnackbar(true,'success','Sales order processed successfully!'))
        navigate(-1)
        setFlag(false)
      }
    },[flag])
return(
<div>
{data.onPress && 
    <div style={{backgroundColor:'white', position : 'absolute', zIndex:1150, top:0,left : 0,  padding: 1}}>
<Printer type="epson" width={42}>
<Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:20}} textTransform="uppercase">GIRLUSH</Typography>
<Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:16}} >{data.getThermalData.companyInfo.acname}</Typography>
<Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:16}} textTransform="uppercase">{data.getThermalData.companyInfo.fullname}</Typography>
<Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13}}>{data.getThermalData.companyInfo.add1}</Typography>
<Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13}}>{data.getThermalData.companyInfo.add2} - {data.getThermalData.companyInfo.pincode}</Typography>
<Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13}}>Mobile : +91{data.getThermalData.companyInfo.mobile}</Typography>
<Typography fontWeight={600} sx={{ color:'black', textAlign : 'center',  textWrap:'wrap',  fontSize:13}}>GSTIN - {data.getThermalData.companyInfo.gstin}</Typography>
{/* <Text>--------------------------------------------</Text> */}
<Typography fontWeight={600} sx={{ color:'black', textAlign : 'left',  textWrap:'wrap',  fontSize:13,borderTop:"1px solid",borderBottom:"1px solid",marginBlock:.5,paddingTop:.5,paddingInline:1}}>Employee : {data.getThermalData.TotalData.employee}</Typography>
<Grid sx={{paddingInline:1}}>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>Date</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right"}}>{data.getThermalData.TotalData.date}</Typography>
        </div>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>Openning Balance</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right"}}>{data.getThermalData.TotalData.opening_balance}</Typography>
        </div>
        <div className='flex items-center justify-between'>
            <Typography sx={{fontWeight: 600, fontSize:13,width: "160px !important"}}>Total Expense Amount</Typography>
            <Typography >: </Typography>
            <Typography sx={{fontSize:13,width: "70px !important",textAlign:"right"}}>{data.getThermalData.TotalData.expences_amount}</Typography>
        </div>
    </Grid>
        <TableContainer sx={{paddingInline:1, width: '100%'}}>
            <Table sx={{ width: '100%'}}>
                <TableBody>
                    <TableRow>
                            <TableCell className={classes.headCell} align='left' sx={{ width:30,fontWeight: 600, fontSize:12}}>Sno</TableCell>
                            <TableCell className={classes.headCell} align='center' sx={{width:60, fontWeight: 600}}>Denomination</TableCell>
                            <TableCell className={classes.headCell} align='center'  sx={{width:60, fontWeight: 600}}>Count</TableCell>
                            <TableCell className={classes.headCell} align='right'  sx={{width:65, fontWeight: 600}}>Amoint</TableCell>
                        </TableRow>
                            {_.map(data.getThermalData.tableData,(val,idx)=>(
                                <TableRow key={idx} className={classes.tblRowCell}>
                                <TableCell  align='left'>{idx + 1}</TableCell>
                                <TableCell align='center' >{parseFloat(val.denomination).toFixed(2)}</TableCell>
                                <TableCell align='center'>{val.count}</TableCell>
                                <TableCell align='right'>{val.total}</TableCell>
                                </TableRow> 
                            ))}
                        <TableRow>
                        <TableCell className={classes.headCell} colSpan={2}/>
                        <TableCell className={classes.headCell} colSpan={1} align='left'  sx={{ color:'black', fontSize : 12}}> Grand Total </TableCell>
                        <TableCell className={classes.headCell}  align='right' sx={{fontWeight : 600, color:'black', fontSize : 17}}>{data.getThermalData.TotalData.tot}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
{/* <Typography textAlign='center'fontWeight={600} sx={{color:'black', fontSize: 13}}>Order Online: www.buygirlush.com</Typography> */}
<Typography textAlign='center'fontWeight={600} sx={{ color:'black',fontSize: 13,marginBlock:1}}>***  THANK YOU! VISIT AGAIN ***</Typography>
<Cut />

</Printer>
</div>}
</div>
)
}

export default memo(ExpenseCloseThermalPrint)